import { Theme, useMediaQuery } from "@mui/material"
import { ReactElement } from "react"

import NavBarWrapper from "./navBar/navBarWrapper"
import { useGetUserData } from "../../hooks/useGetUserData"

type NavigationWrapperProps = {
    children: ReactElement
}

/**
 * Parent wrapper for navigation components. Appends navigation components into
 * application content box (which should be supplied to this component via
 * `children`). When APPLICATION is rendered in desktop mode, it returns an
 * element displaying content and the navigation bar. In mobile mode, it
 * returns content with the mobile navigation speed-dial.
 *
 * @example
 * <NavigationWrapper>
 *     <ApplicationContentBox>
 * </NavigationWrapper>
 */
const NavigationWrapper = ({
    children,
}: NavigationWrapperProps): ReactElement => {
    const { groups } = useGetUserData()
    const isMob = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"))
    return isMob ? (
        children
    ) : (
        <NavBarWrapper groups={groups}>{children}</NavBarWrapper>
    )
}

export default NavigationWrapper
